export default __webpack_public_path__ + "static/media/error-icon.fe52aace.svg";